import React from "react";
import Select from "react-select";
import { Input } from "../../components/ui/input";
import { Switch } from "../../components/ui/Switch"; 

const Filter = ({ type, label, name, value, onChange, options = [], isMulti = false }) => {
  const handleChange = (val) => {
    onChange(name, type === "select" ? (isMulti ? val : val?.value) : val);
  };

  return (
    <div className="mb-1">
      <label className="block   font-medium text-gray-700">{label}</label>

      {type === "input" && (
        <Input
          value={value || ""}
          onChange={(e) => handleChange(e.target.value)}
        />
      )}

      {type === "select" && (
        <Select
          options={options}
          value={isMulti
            ? options.filter((o) => value?.includes(o.value))
            : options.find((o) => o.value === value)}
          onChange={handleChange}
          isMulti={isMulti}
        />
      )}

      {type === "switch" && (
        <Switch checked={value} onCheckedChange={(val) => handleChange(val)} />
      )}
    </div>
  );
};

export default Filter;
